import { Headers } from '@frontend/header';
import { useTranslation } from '@frontend/i18n';
import { Page } from '@frontend/page';
import { useIsCompactMode } from '@frontend/responsiveness';
import { useAppScopeStore } from '@frontend/scope';
import { VoicemailActionBar } from './voicemail-action-bar';

interface VoicemailHeaderProps {
  selectedTimeRange: string;
  setSelectedTimeRange: (timeRange: string) => void;
}
export const VoicemailHeader = ({ selectedTimeRange, setSelectedTimeRange }: VoicemailHeaderProps) => {
  const { t } = useTranslation('calls', { keyPrefix: 'voicemails' });
  const isCompactMode = useIsCompactMode();
  const { selectedLocationIds } = useAppScopeStore();

  const isMultiLocationSelected = selectedLocationIds.length > 1;

  // only inline when compact + single location
  const showInlineActionBar = isCompactMode && !isMultiLocationSelected;

  return (
    <>
      <Headers.TitleRow>
        <Headers.Title>
          <Headers.RouterHeader title={t('Voicemails')} />

          {showInlineActionBar && <VoicemailActionBar setSelectedTimerange={setSelectedTimeRange} />}
        </Headers.Title>
      </Headers.TitleRow>

      {!showInlineActionBar && isCompactMode && <VoicemailActionBar setSelectedTimerange={setSelectedTimeRange} />}

      <Page.Header.Subtitle
        subtitle={
          !!selectedTimeRange &&
          t(`Showing results for {{timerange}}.`, {
            timerange: selectedTimeRange,
          })
        }
      />
    </>
  );
};
